import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const ConsentsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		consentid: yup.string().required().label("Consentid"),
		shopname: yup.string().required().label("Shopname"),
		ownername: yup.string().required().label("Ownername"),
		email: yup.string().email().required().label("Email"),
		phone: yup.string().required().label("Phone"),
		shopaddress: yup.string().required().label("Shopaddress"),
		shopid: yup.string().required().label("Shopid"),
		agreetoterms: yup.string().required().label("Agreetoterms"),
		agreetodataprocessing: yup.string().required().label("Agreetodataprocessing"),
		agreetomarketing: yup.string().required().label("Agreetomarketing"),
		agreetoliability: yup.string().required().label("Agreetoliability"),
		signaturedata: yup.string().nullable().label("Signaturedata"),
		ipaddress: yup.string().nullable().label("Ipaddress"),
		useragent: yup.string().nullable().label("Useragent"),
		verificationhash: yup.string().nullable().label("Verificationhash"),
		emailverified: yup.string().email().required().label("Emailverified"),
		emailverifiedat: yup.string().nullable().label("Emailverifiedat"),
		otpcode: yup.string().nullable().label("Otpcode"),
		otpexpiry: yup.string().nullable().label("Otpexpiry"),
		otpattempts: yup.number().required().label("Otpattempts"),
		consenttimestamp: yup.string().required().label("Consenttimestamp"),
		createdat: yup.string().required().label("Createdat"),
		updatedat: yup.string().nullable().label("Updatedat")
	});
	// form default values
	const formDefaultValues = {
		consentid: '', 
		shopname: '', 
		ownername: '', 
		email: '', 
		phone: '', 
		shopaddress: '', 
		shopid: '', 
		agreetoterms: "((0))", 
		agreetodataprocessing: "((0))", 
		agreetomarketing: "((0))", 
		agreetoliability: "((0))", 
		signaturedata: '', 
		ipaddress: '', 
		useragent: '', 
		verificationhash: '', 
		emailverified: "((0))", 
		emailverifiedat: new Date(), 
		otpcode: '', 
		otpexpiry: new Date(), 
		otpattempts: "((0))", 
		consenttimestamp: "(getutcdate())", 
		createdat: "(getutcdate())", 
		updatedat: new Date(), 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/consents`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="ConsentsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Consent"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Consentid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="consentid"  onChange={formik.handleChange}  value={formik.values.consentid}   label="Consentid" type="text" placeholder="Enter Consentid"        className={inputClassName(formik?.errors?.consentid)} />
                                                <ErrorMessage name="consentid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Shopname *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="shopname"  onChange={formik.handleChange}  value={formik.values.shopname}   label="Shopname" type="text" placeholder="Enter Shopname"        className={inputClassName(formik?.errors?.shopname)} />
                                                <ErrorMessage name="shopname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Ownername *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ownername"  onChange={formik.handleChange}  value={formik.values.ownername}   label="Ownername" type="text" placeholder="Enter Ownername"        className={inputClassName(formik?.errors?.ownername)} />
                                                <ErrorMessage name="ownername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Email *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="email"  onChange={formik.handleChange}  value={formik.values.email}   label="Email" type="email" placeholder="Enter Email"        className={inputClassName(formik?.errors?.email)} />
                                                <ErrorMessage name="email" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Phone *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="phone"  onChange={formik.handleChange}  value={formik.values.phone}   label="Phone" type="text" placeholder="Enter Phone"        className={inputClassName(formik?.errors?.phone)} />
                                                <ErrorMessage name="phone" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Shopaddress *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="shopaddress"  onChange={formik.handleChange}  value={formik.values.shopaddress}   label="Shopaddress" type="text" placeholder="Enter Shopaddress"        className={inputClassName(formik?.errors?.shopaddress)} />
                                                <ErrorMessage name="shopaddress" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Shopid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="shopid"  onChange={formik.handleChange}  value={formik.values.shopid}   label="Shopid" type="text" placeholder="Enter Shopid"        className={inputClassName(formik?.errors?.shopid)} />
                                                <ErrorMessage name="shopid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Agreetoterms *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="agreetoterms"  onChange={formik.handleChange}  value={formik.values.agreetoterms}   label="Agreetoterms" type="text" placeholder="Enter Agreetoterms"        className={inputClassName(formik?.errors?.agreetoterms)} />
                                                <ErrorMessage name="agreetoterms" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Agreetodataprocessing *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="agreetodataprocessing"  onChange={formik.handleChange}  value={formik.values.agreetodataprocessing}   label="Agreetodataprocessing" type="text" placeholder="Enter Agreetodataprocessing"        className={inputClassName(formik?.errors?.agreetodataprocessing)} />
                                                <ErrorMessage name="agreetodataprocessing" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Agreetomarketing *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="agreetomarketing"  onChange={formik.handleChange}  value={formik.values.agreetomarketing}   label="Agreetomarketing" type="text" placeholder="Enter Agreetomarketing"        className={inputClassName(formik?.errors?.agreetomarketing)} />
                                                <ErrorMessage name="agreetomarketing" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Agreetoliability *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="agreetoliability"  onChange={formik.handleChange}  value={formik.values.agreetoliability}   label="Agreetoliability" type="text" placeholder="Enter Agreetoliability"        className={inputClassName(formik?.errors?.agreetoliability)} />
                                                <ErrorMessage name="agreetoliability" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Signaturedata 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="signaturedata"  onChange={formik.handleChange}  value={formik.values.signaturedata}   label="Signaturedata" type="text" placeholder="Enter Signaturedata"        className={inputClassName(formik?.errors?.signaturedata)} />
                                                <ErrorMessage name="signaturedata" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Ipaddress 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ipaddress"  onChange={formik.handleChange}  value={formik.values.ipaddress}   label="Ipaddress" type="text" placeholder="Enter Ipaddress"        className={inputClassName(formik?.errors?.ipaddress)} />
                                                <ErrorMessage name="ipaddress" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Useragent 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="useragent"  onChange={formik.handleChange}  value={formik.values.useragent}   label="Useragent" type="text" placeholder="Enter Useragent"        className={inputClassName(formik?.errors?.useragent)} />
                                                <ErrorMessage name="useragent" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Verificationhash 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="verificationhash"  onChange={formik.handleChange}  value={formik.values.verificationhash}   label="Verificationhash" type="text" placeholder="Enter Verificationhash"        className={inputClassName(formik?.errors?.verificationhash)} />
                                                <ErrorMessage name="verificationhash" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Emailverified *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="emailverified"  onChange={formik.handleChange}  value={formik.values.emailverified}   label="Emailverified" type="email" placeholder="Enter Emailverified"        className={inputClassName(formik?.errors?.emailverified)} />
                                                <ErrorMessage name="emailverified" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Emailverifiedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="emailverifiedat" value={formik.values.emailverifiedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.emailverifiedat)}        />
                                                <ErrorMessage name="emailverifiedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Otpcode 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="otpcode"  onChange={formik.handleChange}  value={formik.values.otpcode}   label="Otpcode" type="text" placeholder="Enter Otpcode"        className={inputClassName(formik?.errors?.otpcode)} />
                                                <ErrorMessage name="otpcode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Otpexpiry 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="otpexpiry" value={formik.values.otpexpiry} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.otpexpiry)}        />
                                                <ErrorMessage name="otpexpiry" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Otpattempts *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="otpattempts"  onChange={formik.handleChange}  value={formik.values.otpattempts}   label="Otpattempts" type="number" placeholder="Enter Otpattempts"  min={0}  step="any"    className={inputClassName(formik?.errors?.otpattempts)} />
                                                <ErrorMessage name="otpattempts" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Consenttimestamp *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="consenttimestamp" value={formik.values.consenttimestamp} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.consenttimestamp)}        />
                                                <ErrorMessage name="consenttimestamp" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Updatedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="updatedat" value={formik.values.updatedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updatedat)}        />
                                                <ErrorMessage name="updatedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
ConsentsEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'consents',
	apiPath: 'consents/edit',
	routeName: 'consentsedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ConsentsEditPage;
